export default __webpack_public_path__ + "static/media/eco-car.c7a0a683.svg";